<template>
    <div style="position:relative;padding-bottom:60px">
        <v-layout class="d-flex justify-space-between flex-wrap">
            <v-btn class="transition" color="primary" rounded @click="toggleFiltro">
                <v-icon small style="margin-right: 10px;">mdi-filter</v-icon>
                Filtrar por:
                <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
            </v-btn>
            <v-btn color="primary" @click="exportarExcel">
                <v-icon left size="18">
                    mdi-file-chart
                </v-icon>
                SALVAR RELATÓRIO
            </v-btn>
        </v-layout>
        <collapse-transition>
            <v-form ref="filter" v-if="filter_open" class="mt-4 ml-2">
                <v-row>
                    <v-col cols="6">
                        <DynamicSelect
                                label="Usuário:"
                                id="FieldIdUsuarioErp"
                                v-model="filters.usuario"
                                attach
                                placeholder="Selecione o Usuário"
                                endpoint="/dynamic-selects/usuarios/login"
                                :multiple="false"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-select
                                outlined
                                label="Status do usuário:"
                                placeholder="Selecione o status"
                                :items="statusOptions"
                                v-model="filters.status"
                                clearable
                        />
                    </v-col>
                    <v-col cols="6">
                        <DynamicSelect
                                label="Responsável pela alteração:"
                                id="FieldIdResponsavelAlteracao"
                                v-model="filters.responsavel"
                                attach
                                placeholder="Selecione o Responsável"
                                endpoint="/dynamic-selects/usuarios/login"
                                :multiple="false"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <date-time-range
                                v-model="filters.data_hora_range"
                                :hide-time="true"
                                label="Data/Hora"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                                v-model="filters.cpf"
                                label="CPF/CNPJ"
                                outlined
                                placeholder="Insira o CPF/CNPJ"
                                hide-details
                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                                :maxlength="20"
                        />
                    </v-col>
                </v-row>
                <v-row class="justify-end align-center mt-4">
                    <v-col cols="6" md="3">
                        <v-btn color="secondary" block @click="limparFiltros">
                            Limpar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-btn color="primary" block @click="aplicarFiltros">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </collapse-transition>
        <DataTable
                ref="datatable"
                url="/painel/backoffice/usuarios_bloqueados"
                class="pt-2"
                :headers="headers"
                :params="params"
        >
            <template v-slot:items="{item}">
                <td>{{ item.login }} - {{ item.nome }}</td>
                <td class="text-center" style="width: 200px;">{{ item.cpf | formatarCpfCnpj }}</td>
                <td>
                    <v-select
                            :items="statusOptions"
                            :value="getStatusValue(item)"
                            @change="status => confirmStatusChange(item, status)"
                            return-object
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            placeholder="Selecione um status"
                    ></v-select>
                </td>
                <td class="text-center">{{ item.historico && item.historico.data_alteracao ? item.historico.data_alteracao : '-' }}</td>
                <td class="text-center">{{ item.historico && item.historico.login ? item.historico.login : ' - ' }}</td>
                <td class="text-center">{{ item.historico && item.historico.nome_responsavel ? item.historico.nome_responsavel : ' - ' }}</td>
                <td class="text-center">{{ item.historico && item.historico.justificativa ? item.historico.justificativa : ' - ' }}</td>
            </template>
        </DataTable>
        <DialogChangeStatusUser
                :value="changeStatusDialog.open"
                @input="changeStatusDialog.open = $event"
                @submit="handleStatusChange"
                @reload="reloadData"
        />
    </div>
</template>

<script>
  import { notification, alert } from '@/plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'
  import DialogChangeStatusUser from '../../dialogs/DialogChangeStatusUser.vue'
  import DateTimeRange from '../../components/DateTimeRange.vue'
  import * as Qs from 'qs'

  export default {
    name: 'UsuariosBloqueados',
    components: {
      DateTimeRange,
      DialogChangeStatusUser
    },
    data: () => ({
      headers: [
        { text: 'Usuário', value: 'nome' },
        { text: 'CPF/CNPJ', value: 'cpf', align: 'center' },
        { text: 'Status do usuário', value: 'status', sortable: false },
        { text: 'Data/Hora da alteração', value: 'data_alteracao' },
        { text: 'Código do responsável pela alteração', value: 'login', sortable: false },
        { text: 'Usuário responsável pela alteração', value: 'nome_responsavel', sortable: false },
        { text: 'Justificativa', value: 'justificativa', sortable: false, align: 'center' }
      ],
      statusOptions: [
        { text: 'Liberado', value: false },
        { text: 'Bloqueado', value: true }
      ],
      filters: {
        usuario: null,
        cpf: null,
        status: null,
        responsavel: null,
        data_hora_range: ['', '']
      },
      params: {
        pagination: {
          rowsPerPage: 12,
          page: 1,
          sortBy: 'id_usuario',
          descending: false
        },
        filters: {}
      },
      filter_open: false,
      usuarios: [],
      changeStatusDialog: {
        open: false,
        item: null,
        newStatus: null
      }
    }),
    methods: {
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      aplicarFiltros () {
        this.params.filters = {
          usuario: this.filters.usuario ? this.filters.usuario : null,
          responsavel: this.filters.responsavel ? this.filters.responsavel : null,
          cpf: this.filters.cpf,
          status: this.filters.status,
          data_inicial: this.filters.data_hora_range[0],
          data_final: this.filters.data_hora_range[1]
        }
        this.$refs.datatable.reload()
      },
      limparFiltros () {
        this.filters = {
          usuario: null,
          cpf: null,
          status: null,
          responsavel: null,
          data_hora_range: ['', '']
        }
        this.params.filters = {}

        this.$refs.datatable.reload()
      },
      getStatusValue (item) {
        if (!item.historico || item.historico.status === undefined) {
          return false
        }
        return item.historico.status
      },
      exportarExcel () {
        const filtros = { ...this.params.filters }
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: 'id_usuario', descending: false },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/usuarios_bloqueados/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      confirmStatusChange (item, newStatus) {
        const currentStatus = this.getStatusValue(item)

        if (newStatus.value === currentStatus) return

        alert({
          text: `Tem certeza que deseja alterar o status do usuário "${item.nome}" para "${newStatus.text}"?`,
          buttons: {
            Cancelar: () => {
              this.$refs.datatable.reload()
            },
            Confirmar: () => {
              this.openChangeStatusDialog(item, newStatus)
            }
          }
        })
      },
      openChangeStatusDialog (item, newStatus) {
        this.changeStatusDialog = {
          open: true,
          item,
          newStatus
        }
      },
      handleStatusChange (justificativa) {
        const { item, newStatus } = this.changeStatusDialog

        if (!item.historico) {
          item.historico = {}
        }
        item.historico.justificativa = justificativa

        this.updateStatus(item, newStatus)
      },
      reloadData () {
        this.$refs.datatable.reload()
      },
      async updateStatus (item, status) {
        try {
          const idResponsavel = this.$session.get('id_usuario_interno')

          if (!idResponsavel) {
            notification(AlertTypes.ERROR, 'Usuário não autenticado. Por favor, realize o login novamente.')
            return
          }

          const justificativa = item.historico && item.historico.justificativa ? item.historico.justificativa : null

          const response = await this.$http.put(`/painel/backoffice/usuarios_bloqueados/${item.id_usuario}`, {
            status: status.value,
            justificativa: justificativa,
            id_responsavel: idResponsavel
          })

          notification(AlertTypes.SUCCESS, response.data.message || 'Status atualizado com sucesso!')
          this.$refs.datatable.reload()
          item.historico.status = status.value
        } catch (error) {
          const errorMessage = error.response?.data?.message || 'Erro ao atualizar o status. Por favor, tente novamente.'
          notification(AlertTypes.ERROR, errorMessage)
        }
      }
    }
  }
</script>
